import { Component, OnInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ViewTableComponent } from '../../base/view-table/view-table.component';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'src/app/services/utility.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { FormBuilder } from '@angular/forms';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Renderer2 } from '@angular/core';
import { PrintService } from 'src/app/services/print.service';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { WeekYearChangeEvent } from '../../shared/week-year-selector/week-year-selector.component';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-weekly-enrollment-sales-tracking-report',
  templateUrl: './weekly-enrollment-sales-tracking-report.component.html',
  styleUrls: ['./weekly-enrollment-sales-tracking-report.component.css']
})
export class WeeklyEnrollmentSalesTrackingReportComponent extends ViewTableComponent implements OnInit {

  year: string;
  week: string;
  override WeeksForYearData: any[] = [];
  override LastFourYearsData: any[] = this.getLastFourYears();
  consumable: any;
  inquiriesData: any[] = [];
  inquiryTotals: { contacts: number, booked: number, showed: number } | null = null;
  deEnrollmentsData: any[] = [];
  preEnrollmentsData: any[] = [];
  oriData: any[] = [];
  extData: any[] = [];
  renData: any[] = [];
  nonUnitSalesData: any[] = [];
  miscSalesData: any[] = [];
  dateTimeRange: Date[] = [];
  isDateRangeActive: boolean = false;

  constructor(
    public override _refreshService: RefreshService,
    private _printService: PrintService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  getCurrentWeek() {
    return this._fieldsService.getCurrentWeek().toString();
  }

  private getCurrentWeekYear(): string {
    return this._fieldsService.getCorrectYearForWeek(new Date()).toString();
  }

  override ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      if (params['date_from'] && params['date_to']) {
        const startDate = this.reportDateService.parseCalendarDateInput(params['date_from']);
        const endDate = this.reportDateService.parseCalendarDateInput(params['date_to']);

        this.dateTimeRange = [
          startDate,
          endDate
        ].filter((date): date is Date => !!date);

        if (this.dateTimeRange.length !== 2) {
          this.dateTimeRange = [];
          this.isDateRangeActive = false;
          this.year = this.getCurrentWeekYear();
          this.week = this.getCurrentWeek();
          this.onYearChange(this.year);
          this.loadData();
          return;
        }

        this.dateTimeRange = [
          startDate as Date,
          endDate as Date
        ];
        this.isDateRangeActive = true;
        this.year = this.getCurrentWeekYear();
        this.week = this.getCurrentWeek();
        this.onYearChange(this.year);
        this.loadData();
      } else {
        this.isDateRangeActive = false;
        this.year = params['year'] || this.getCurrentWeekYear();
        this.week = params['week'] || this.getCurrentWeek();
        this.onYearChange(this.year);
        this.loadData();
      }
    });
  }

  onYearChange(year: string) {
    this.year = year;
    this.WeeksForYearData = this._fieldsService.WeeksForYearData(Number(this.year));
  }

  onWeekYearChange(event: WeekYearChangeEvent): void {
    this.week = event.week;
    this.year = event.year;
    this.isDateRangeActive = event.isDateRangeActive;

    if (event.isDateRangeActive && event.dateRange) {
      this.dateTimeRange = [event.dateRange.start, event.dateRange.end];
    } else {
      this.dateTimeRange = [];
    }

    this.loadData();
  }

  override dataSource = new MatTableDataSource<any>([]);

  override ngAfterContentInit(): void {
    this._activatedRoute.queryParams.subscribe(data => {
      this.week = data['week'] || this.getCurrentWeek();
      this.year = data['year'] || this.getCurrentWeekYear();
      this.loadData();
    });
  }

  dateRangeChange(event: any) {
    if (event.value && Array.isArray(event.value)) {
      this.dateTimeRange = event.value;
      this.isDateRangeActive = true;
      this.loadData();
    }
  }

  loadData() {
    if (this.isDateRangeActive && this.dateTimeRange?.length > 0) {
      this.getData([
        { parameter: 'date_from', value: this.reportDateService.formatCalendarParam(this.dateTimeRange[0]) },
        { parameter: 'date_to', value: this.reportDateService.formatCalendarParam(this.dateTimeRange[1]) }
      ]);
    } else if (this.week && this.year) {
      this.getData([
        { parameter: 'week', value: this.week.toString() },
        { parameter: 'year', value: this.year }
      ]);
    }
  }

  override getData(params: { parameter: string; value: string }[]) {
    this.ShowProgressBar = true;

    if (!params.some(p => p.parameter === 'date_from')) {
      params.push({ parameter: 'weekYear', value: this.year.toString() });
      params.push({ parameter: 'weekNumber', value: this.week.toString() });
    }

    this._drupalRESTService.httpGET('/api_rest/v1/loadWeeklyEnrollmentSalesTrackingReport', params).subscribe(
      data => {
        this.ShowProgressBar = false;
        this.inquiriesData = (data?.['inquiry_merged_report'] || []).map(item => ({
          name: item.title,
          callDates: this.reportDateService.formatDate(item.field_inquiry_date),
          bookingDates: this.reportDateService.formatDate(item.field_booked_date),
          showedDates: this.reportDateService.formatDate(item.field_showed_date),
          executive: item.executive || '',
          teacher: item.teacher || ''
        }));
        this.numberInquiryActivities();
        this.inquiryTotals = data?.['inquiry_totals'] || null;
        this.deEnrollmentsData = data?.['dance_evaluation_report'] || [];
        this.preEnrollmentsData = data?.['pre_original_report'] || [];
        this.oriData = data?.['original_report'] || [];
        this.extData = data?.['extension_report'] || [];
        this.renData = data?.['renewal_report'] || [];
        this.nonUnitSalesData = data?.['non_unit_report'] || [];
        this.miscSalesData = data?.['miscellaneous_report'] || [];
      },
      error => this.handleError(error)
    );
  }

  // Mirrors the Sale/No Sale report: "No Sale" only when the enrollment is
  // marked no-sale (completed with no later purchase); blank while still open.
  formatOutcome(outcome: any): string {
    if (!outcome) {
      return '';
    }
    if (outcome.no_sale) {
      return 'No Sale';
    }
    const date = outcome.purchased_date ? this.reportDateService.formatDate(outcome.purchased_date) : '';
    if (outcome.package_name) {
      return date ? `${outcome.package_name}, purchased ${date}` : outcome.package_name;
    }
    return date ? `Purchased ${date}` : '✓';
  }

  isPurchasedOutcome(outcome: any): boolean {
    return !!outcome && !outcome.no_sale;
  }

  // Each activity column is numbered independently so the totals of each
  // activity can be compared across the reporting period, e.g. 5 contacts
  // numbered (1)-(5) while the same rows' 3 bookings are numbered (1)-(3).
  private numberInquiryActivities(): void {
    let contactSeq = 0;
    let bookingSeq = 0;
    let showedSeq = 0;
    for (const row of this.inquiriesData) {
      if (row.callDates) {
        row.callDates = `(${++contactSeq}) ${row.callDates}`;
      }
      if (row.bookingDates) {
        row.bookingDates = `(${++bookingSeq}) ${row.bookingDates}`;
      }
      if (row.showedDates) {
        row.showedDates = `(${++showedSeq}) ${row.showedDates}`;
      }
    }
  }

  private getLastFourYears(): any[] {
    const currentYear = moment().year();
    return Array.from({ length: 4 }, (_, i) => ({
      key: (currentYear - i).toString(),
      value: (currentYear - i).toString()
    }));
  }

  private generateInquiriesSection(): string {
    if (this.inquiriesData.length === 0) {
      return '<div class="section"><h3>Inquiries (0)</h3><p>No inquiries found for this period</p></div>';
    }

    const table = this.generateTable(
      ['Name', 'Contact Date', 'Booking Date', 'Showed Date', 'Executive', 'Teacher'],
      this.inquiriesData,
      {
        name: (item) => item.name || '',
        callDates: (item) => item.callDates || '',
        bookingDates: (item) => item.bookingDates || '',
        showedDates: (item) => item.showedDates || '',
        executive: (item) => item.executive || '',
        teacher: (item) => item.teacher || ''
      }
    );

    const totalsLine = this.inquiryTotals
      ? `<p>Total Contacts: ${this.inquiryTotals.contacts} &mdash; Total Booked: ${this.inquiryTotals.booked} &mdash; Total Showed: ${this.inquiryTotals.showed}</p>`
      : '';

    return `<div class="section"><h3>Inquiries (${this.inquiriesData.length})</h3>${totalsLine}${table}</div>`;
  }

  private generateEnrollmentSection(title: string, data: any[]): string {
    if (!data || data.length === 0) {
      return '';
    }

    const table = this.generateTable(
      ['Student Name', 'Package', 'Date Enrolled', '# of Lessons', 'Amount ($)', 'Teachers', 'Outcome'],
      data,
      {
        student_name: (item) => item.student_name || '',
        package_name: (item) => item.package_name || '',
        date_enrolled: (item) => this.reportDateService.formatDate(item.date_enrolled),
        lessons_enrolled: (item) => item.lessons_enrolled || '',
        amount: (item) => item.amount ? '$' + parseFloat(item.amount).toFixed(2) : '',
        teachers: (item) => item.teachers || '',
        outcome: (item) => this.formatOutcome(item.outcome)
      }
    );

    return `<div class="section"><h3>${this.escapeHtml(title)} (${data.length})</h3>${table}</div>`;
  }

  override onPrint() {
    try {
      // Build HTML content using helper methods
      let content = `
        <h2 class="report-title">Weekly Enrollment Sales Tracking Report</h2>
        <p class="report-period">
          ${this.isDateRangeActive && this.dateTimeRange?.length > 0
            ? `Date Range: ${this.reportDateService.formatDate(this.dateTimeRange[0])} to ${this.reportDateService.formatDate(this.dateTimeRange[1])}`
            : `Week: ${this.escapeHtml(this.week)}, Year: ${this.escapeHtml(this.year)}`
          }
        </p>
      `;

      // Add sections using helper methods
      content += this.generateInquiriesSection();

      content += this.generateEnrollmentSection('DE Enrollments', this.deEnrollmentsData);

      content += this.generateEnrollmentSection('Pre Enrollments', this.preEnrollmentsData);

      content += this.generateEnrollmentSection('ORIs', this.oriData);

      content += this.generateEnrollmentSection('EXTs', this.extData);

      content += this.generateEnrollmentSection('RENs', this.renData);

      content += this.generateEnrollmentSection('Non-Unit Sales', this.nonUnitSalesData);

      content += this.generateEnrollmentSection('Miscellaneous Sales', this.miscSalesData);

      // Optimized styles - only include report-specific customizations
      // PrintService already provides base table, section, and typography styles
      const styles = `
        .report-title {
          font-size: 24px;
          margin-bottom: 10px;
        }
        .report-period {
          font-size: 16px;
          margin-bottom: 30px;
        }
        .section {
          margin-bottom: 30px;
        }
        .section h3 {
          color: #333;
          border-bottom: 1px solid #ddd;
          padding-bottom: 5px;
        }
        tr:nth-child(even) {
          background-color: #f9f9f9;
        }
      `;

      // Create a formatted title
      let title = 'Weekly Enrollment Sales Tracking Report';
      if (this.isDateRangeActive && this.dateTimeRange?.length > 0) {
        const startDate = this.reportDateService.formatDate(this.dateTimeRange[0]);
        const endDate = this.reportDateService.formatDate(this.dateTimeRange[1]);
        title += ` - ${startDate} to ${endDate}`;
      } else {
        title += ` - Week ${this.escapeHtml(this.week)}, ${this.escapeHtml(this.year)}`;
      }

      this._printService.print(content, {
        title,
        styles,
        showSchoolName: true,
        promptPrint: true
      });
    } catch (error) {
      LoggerService.error('Error generating print preview:', error);
      this._snackBar.open('Unable to generate print preview. Please try again.', 'Close', {
        duration: 3000
      });
    }
  }

  exportToCsv() {
    const periodLabel = this.isDateRangeActive && this.dateTimeRange?.length > 0
      ? `Date Range: ${this.reportDateService.formatDate(this.dateTimeRange[0])} to ${this.reportDateService.formatDate(this.dateTimeRange[1])}`
      : `Week: ${this.week}, Year: ${this.year}`;

    const rows: string[][] = [];
    rows.push(['Weekly Sales Tracking Report']);
    rows.push([periodLabel]);
    rows.push([]);

    const enrollmentHeaders = ['Student Name', 'Package', 'Date Enrolled', '# of Lessons', 'Amount ($)', 'Teachers', 'Outcome'];
    const nonUnitHeaders = ['Student Name', 'Package', 'Date', 'Quantity', 'Amount ($)', 'Teachers', 'Outcome'];
    const miscHeaders = ['Customer Name', 'Package', 'Date', 'Quantity', 'Amount ($)', 'Teachers', 'Outcome'];

    const appendEnrollmentSection = (title: string, data: any[], headers: string[]) => {
      rows.push([`${title} (${data?.length || 0})`]);
      if (!data || data.length === 0) {
        rows.push(['No records found for this period']);
      } else {
        rows.push(headers);
        for (const item of data) {
          rows.push([
            item.student_name || '',
            item.package_name || '',
            this.reportDateService.formatDate(item.date_enrolled) || '',
            (item.lessons_enrolled ?? '').toString(),
            item.amount ? parseFloat(item.amount).toFixed(2) : '',
            item.teachers || '',
            this.formatOutcome(item.outcome)
          ]);
        }
      }
      rows.push([]);
    };

    rows.push([`Inquiries (${this.inquiriesData?.length || 0})`]);
    if (this.inquiryTotals) {
      rows.push(['Total Contacts', this.inquiryTotals.contacts.toString()]);
      rows.push(['Total Booked', this.inquiryTotals.booked.toString()]);
      rows.push(['Total Showed', this.inquiryTotals.showed.toString()]);
    }
    if (!this.inquiriesData || this.inquiriesData.length === 0) {
      rows.push(['No inquiries found for this period']);
    } else {
      rows.push(['Name', 'Contact Date', 'Booking Date', 'Showed Date', 'Executive', 'Teacher']);
      for (const item of this.inquiriesData) {
        rows.push([
          item.name || '',
          item.callDates || '',
          item.bookingDates || '',
          item.showedDates || '',
          item.executive || '',
          item.teacher || ''
        ]);
      }
    }
    rows.push([]);

    appendEnrollmentSection('DE Enrollments', this.deEnrollmentsData, enrollmentHeaders);
    appendEnrollmentSection('Pre Enrollments', this.preEnrollmentsData, enrollmentHeaders);
    appendEnrollmentSection('ORIs', this.oriData, enrollmentHeaders);
    appendEnrollmentSection('EXTs', this.extData, enrollmentHeaders);
    appendEnrollmentSection('RENs', this.renData, enrollmentHeaders);
    appendEnrollmentSection('Non-Unit Sales', this.nonUnitSalesData, nonUnitHeaders);
    appendEnrollmentSection('Miscellaneous Sales', this.miscSalesData, miscHeaders);

    const escapeCell = (val: string) => {
      const s = String(val ?? '');
      return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const csvContent = rows.map(row => row.map(escapeCell).join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const filenameSuffix = this.isDateRangeActive && this.dateTimeRange?.length > 0
      ? `${this.reportDateService.formatCalendarParam(this.dateTimeRange[0])}_to_${this.reportDateService.formatCalendarParam(this.dateTimeRange[1])}`
      : `week-${this.week}-${this.year}`;
    a.download = `weekly-sales-tracking-report-${filenameSuffix}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  private escapeHtml(unsafe: string): string {
    if (!unsafe) return '';
    return String(unsafe)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  private generateTable(headers: string[], rows: any[], fieldMappings: {[key: string]: (item: any) => string}): string {
    if (!rows || rows.length === 0) {
      return '';
    }

    const headerCells = headers.map(h => `<th>${this.escapeHtml(h)}</th>`).join('');
    const headerKeys = Object.keys(fieldMappings);
    
    const bodyRows = rows.map(item => {
      const cells = headerKeys.map(key => {
        const value = fieldMappings[key](item);
        return `<td>${this.escapeHtml(value)}</td>`;
      }).join('');
      return `<tr>${cells}</tr>`;
    }).join('');

    return `
      <table>
        <thead>
          <tr>${headerCells}</tr>
        </thead>
        <tbody>${bodyRows}</tbody>
      </table>
    `;
  }

  override resetForm() {
    this.dateTimeRange = [];
    this.isDateRangeActive = false;
    this.week = this.getCurrentWeek();
    this.year = this.getCurrentWeekYear();
    this.onYearChange(this.year);
    this.loadData();
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }
    // DO NOT call updateRouterParams here - prevents duplicate requests
  }
}
